import { Navigate, Routes, Route } from 'react-router-dom';

import CloudApprovalMat from '@/Pages/motoboys/cloud-approval-mat';
import PreRegistration from '@/Pages/motoboys/pre-registration';
import { PlacesPreRegistration } from '@/Pages/Places/pre-registration/places-pre-registration';

function PreCadastroRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="esteira" replace />} />

      <Route path="esteira" element={<PreRegistration />} />

      <Route
        path="entregadores/:deliverymanId"
        element={<CloudApprovalMat />}
      />

      <Route
        path="estabelecimentos/:placeId"
        element={<PlacesPreRegistration />}
      />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default PreCadastroRoutes;
